import React from 'react';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
  Node,
} from '@uncinc/react-drupal-core';

import './style.scss';

const SelectedContent = (props) => {
  const {
    title,
    text,
    linkTitle,
    linkUrl,
    entities,
  } = props;

  return (
    <div className="SelectedContent">
      <Container>
        <div className="row">

          <div className="col-12">
            <div className="SelectedContent__title">
              <h2>{title}</h2>
            </div>
            <div className="SelectedContent__text">
              <WysiwygField
                property="schema:text"
                html={text}
              />
            </div>
          </div>
        </div>
      </Container>

      <Container>
        <div className="row">
          {entities.map((entity, index) => {
            const uuid = entity.get('target_id');
            return (
              <div key={uuid} className="col-12 col-md-6 col-lg-4">
                <Node
                  entity={entity.get('entity')}
                  viewMode="teaser"
                />
              </div>
            );
          })}
        </div>
      </Container>

      <Container>
        <div className="row">

          <div className="col-12">
            <div className="SelectedContent__link">
              <CoreLink className="Button Button--secondary" to={linkUrl}>
                {linkTitle} <i className="icon icon-arrow-right" />
              </CoreLink>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SelectedContent;
